import React from 'react';
import { ProductProvider } from '../store/productContext';
import ProductList from '../components/Product/ProductList';
import { CurrencyProvider } from '../store/currencyContext';

const ProductPage: React.FC = () => (
    <CurrencyProvider>
        <ProductProvider>
            <ProductList />
        </ProductProvider>
    </CurrencyProvider>
);

export default ProductPage;
